import config from "../config";
const base_url = config.base_url;
export const verifyStartPermission = () => {
  return fetch(base_url + "user/partner/start", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
export const checkNewPasswordValidity = (password) => {
  return fetch(base_url + "user/partner/start/check/password", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `password=${password}`,
  });
};
export const partnerUpdateAuth = (
  password_pbdkf2,
  recovery_key_pbdkf2,
  private_key_recovery_key,
  recovery_key_private_key
) => {
  return fetch(base_url + "newuser/partner/auth/update", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `password=${password_pbdkf2}&recovery_key=${recovery_key_pbdkf2}&private_key_recovery_key=${private_key_recovery_key}&recovery_key_private_key=${recovery_key_private_key}`,
  });
};
export const getPartnerDetails = (partner_id) => {
  return fetch(base_url + "admin/partners/view/partner", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `partner_id=${partner_id}`,
  });
};

export const createPartner = async (files, data) => {
  //files is an array containing all the files the user wants to upload
  //for getting the files, you need to use an <input/> using "multiple" property.
  //Then, using the onChange method, you need to assign the selected files into an array this way:
  // const [files, setFiles] = useState()
  //onChange ={(e)=>setFiles(e.target.files)}

  const formData = new FormData();
  for (let file of files) {
    formData.append("file", file);
  }
  formData.append("data", JSON.stringify(data));
  return fetch(base_url + "admin/partners/create/partner", {
    method: "POST",
    mode: "cors",
    credentials: "include",
    body: formData,
  });
};
export const downloadCoupons = () => {
  fetch(base_url + "user/partner/coupons/download", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, /",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.blob();
      } else throw new Error();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Coupons.csv");
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPrefilledData = () => {
  return fetch(base_url + "user/partner/prefilled/data", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
